import request from '@/utils/request'

// 影院列表
export function getCinemaList(data) {
  return request({
    url:'/filmapi/cinema/getCinemaInfoList',
    method:'post',
    data:data
  })
}
// 热门城市及全部城市
export function allCity(data) {
  return request({
    url:'/filmapi/city/getCityAll',
    method:'post',
    data:data
  })
}
// 影院详情
export function getCinemaDetail(data) {
  return request({
    url:'/filmapi/cinema/getCinemaDetail',
    method:'post',
    data:data
  })
}


// WEBPACK FOOTER //
// ./src/api/cinema.js